import React from 'react';

export default [
  {
    name: 'ClotheShop',
    render: (
      <div className='portfolio-item'>
        <div className='portfolio-item__title'>ClotheShop</div>
        <div className='portfolio-item__desc'>
          E-Commerce web store using React, Redux, Firebase and Firestore{' '}
        </div>
        <div className='portfolio-item__icon'>
          <i className='fab fa-react'></i>
          <i className='fab fa-js'></i>
        </div>
        <div className='portfolio-item__links'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://clotheshop2020.herokuapp.com/'
          >
            ClotheShop
          </a>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://github.com/engammar111/clotheshop'
          >
            Github
          </a>
        </div>
      </div>
    ),
  },
  {
    name: 'Kitten Gardens',
    render: (
      <div className='portfolio-item'>
        <div className='portfolio-item__title'>Kitten Gardens</div>
        <div className='portfolio-item__desc'>Simple React App using Api </div>
        <div className='portfolio-item__icon'>
          <i className='fab fa-react'></i>
          <i className='fab fa-js'></i>
        </div>
        <div className='portfolio-item__links'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://engammar111.github.io/kittensgardens/'
          >
            Kitten Gardens
          </a>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://github.com/engammar111/kittensgardens'
          >
            Github
          </a>
        </div>
      </div>
    ),
  },
  {
    name: 'Contact Manager',
    render: (
      <div className='portfolio-item'>
        <div className='portfolio-item__title'>Contact Manager</div>
        <div className='portfolio-item__desc'>
          Simple Contact manager App using react, redux and redux -Thunk{' '}
        </div>
        <div className='portfolio-item__icon'>
          <i className='fab fa-react'></i>
          <i className='fab fa-js'></i>
        </div>
        <div className='portfolio-item__links'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://engammar111.github.io/contactmanager/'
          >
            Contact Manager
          </a>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://github.com/engammar111/contactmanager'
          >
            Github
          </a>
        </div>
      </div>
    ),
  },
  {
    name: 'Eshop-store',
    render: (
      <div className='portfolio-item'>
        <div className='portfolio-item__title'>Eshop-store</div>
        <div className='portfolio-item__desc'>
          E-commerce store using Angular and Node.js
        </div>
        <div className='portfolio-item__icon'>
          <i className='fab fa-angular'></i>
          <i className='fab fa-js'></i>
        </div>
        <div className='portfolio-item__links'>
          {/* <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://dev.to/flexdinesh/react-redux-boilerplate-with-best-practices--2pp5'
          >
            Blog
          </a> */}
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://github.com/engammar111/Eshop-store'
          >
            Github
          </a>
        </div>
      </div>
    ),
  },
  {
    name: ' Ammar Posts',
    render: (
      <div className='portfolio-item'>
        <div className='portfolio-item__title'> Ammar Posts</div>
        <div className='portfolio-item__desc'>
          Simple social network built on the AmmarMVC PHP framework{' '}
        </div>
        <div className='portfolio-item__icon'>
          <i className='fab fa-php'></i>
          <i className='fab fa-js'></i>
        </div>
        <div className='portfolio-item__links'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='http://ammarposts.ezyro.com/'
          >
            Ammar Posts
          </a>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://github.com/engammar111/sharepost'
          >
            Github
          </a>
        </div>
      </div>
    ),
  },
  {
    name: ' AmmarMVC',
    render: (
      <div className='portfolio-item'>
        <div className='portfolio-item__title'> AmmarMVC</div>
        <div className='portfolio-item__desc'>
          PHP framework using MVC model{' '}
        </div>
        <div className='portfolio-item__icon'>
          <i className='fab fa-php'></i>
        </div>
        <div className='portfolio-item__links'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://github.com/engammar111/AmmarPHPMVC'
          >
            Github
          </a>
        </div>
      </div>
    ),
  },
  {
    name: 'ModernPortfolio',
    render: (
      <div className='portfolio-item'>
        <div className='portfolio-item__title'>Modern Portfolio</div>
        <div className='portfolio-item__desc'>Portfolio app using Sass </div>
        <div className='portfolio-item__icon'>
          <i className='fab fa-sass'></i>
          <i className='fab fa-js'></i>
        </div>
        <div className='portfolio-item__links'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://engammar111.github.io/modernportfolio/'
          >
            Modern Portfolio
          </a>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://github.com/engammar111/modernportfolio/tree/master'
          >
            Github
          </a>
        </div>
      </div>
    ),
  },
];



// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/portfolio-items.js